import React from 'react';
import Box from '../Box/Box';
import getAssetClassName from '../../utils/className/getAssetClassName';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';
import { AssetProps } from './types';

/**
 * Base asset component that interfaces with the svg sprites
 * @param name
 * @param className
 * @param locale
 * @param inverse
 * @param rest
 * @returns {*}
 * @constructor
 */
const AssetBase = ({ name, className: externalClassName = '', inverse, locale, size, kind, ...rest }: AssetProps) => {
  const svgAssetClassName = getAssetClassName(name, inverse, locale);
  const className = `${svgAssetClassName} ${externalClassName}`.trim();
  const conditionalProps = filterConditionalKeyValues({ modifiers: [size, kind] });

  return (
    <Box
      {...rest}
      {...conditionalProps}
      name="Asset"
      as="i"
      aria-hidden="true"
      className={className}
      data-sem="Asset"
    />
  );
};

export default React.memo(AssetBase);
